import React, { Fragment, Component, MouseEvent } from 'react';
import { IconButton, Menu } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import { compose } from 'recompose';

import { withNotify, IWithNotify } from 'providers/NotifyContext';
import { withInboxItems, IWithInboxItems } from 'providers/queries';
import { NotificationsPopup, Notification } from 'features/notifications';

interface IProps {
  onLoaded: () => void;
}

interface IPropsEnhanced extends IProps, IWithNotify, IWithInboxItems, WithStyles<typeof styles> {}

interface IState {
  anchorEl: HTMLElement;
}

const styles = (theme: Theme) =>
  createStyles({
    menu: {
      minHeight: 300,
      width: 300,
    },
    unread: {
      position: 'absolute',
      top: 10,
      right: 10,
      width: theme.spacing(1),
      height: theme.spacing(1),
      backgroundColor: theme.custom.palette.red,
      borderRadius: '50%',
    },
  });

const enhancers = compose<IPropsEnhanced, IProps>(
  withNotify,
  withInboxItems({ loader: 'none', limit: 7 }),
  withStyles(styles),
);

class Notifications extends Component<IPropsEnhanced, IState> {
  state: IState = {
    anchorEl: null,
  };

  componentDidMount() {
    this.props.subscribeToInbox();
    this.props.onLoaded();
  }

  componentDidUpdate(prevProps: IPropsEnhanced) {
    const { inbox, notify } = this.props;
    const prevInbox = prevProps.inbox;

    if (inbox.length === prevInbox.length) {
      return;
    }

    notify.infoSolid({
      duration: 6000,
      placement: 'right',
      component: this.renderToast(),
    });
  }

  hasUnread() {
    const { inbox } = this.props;
    return inbox.some(item => !item.item_read);
  }

  handleMenuOpen = (event: MouseEvent<HTMLButtonElement>) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  renderToast() {
    const { inbox } = this.props;
    const notification = inbox[0];

    if (!notification) {
      return null;
    }

    return <Notification theme="infoSolid" size="regular" item={notification} />;
  }

  render() {
    const { classes } = this.props;
    const { anchorEl } = this.state;

    const isMenuOpen = !!anchorEl;

    return (
      <Fragment>
        <IconButton onClick={this.handleMenuOpen}>
          {this.hasUnread() && <div className={classes.unread} />}
          <NotificationsNoneIcon />
        </IconButton>
        <Menu
          classes={{ paper: classes.menu }}
          anchorEl={anchorEl}
          open={isMenuOpen}
          onClose={this.handleMenuClose}>
          <div>
            <NotificationsPopup onClick={this.handleMenuClose} />
          </div>
        </Menu>
      </Fragment>
    );
  }
}

export default enhancers(Notifications);
